<div class="l1-interview">
  <!-- Interview Introduction Screen -->
  <div class="interview-intro" *ngIf="!interviewStarted && !interviewCompleted">
    <div class="interview-card">
      <div class="interview-card__header">
        <h1 class="interview-card__title">Technical Interview</h1>
        <div class="interview-card__position">{{ interviewInfo.position }}</div>
      </div>

      <div class="interview-card__body">
        <div class="interview-info">
          <div class="interview-info__item">
            <span class="interview-info__label">Company:</span>
            <span class="interview-info__value">{{ interviewInfo.company }}</span>
          </div>
          <div class="interview-info__item">
            <span class="interview-info__label">Total Questions:</span>
            <span class="interview-info__value">{{ interviewInfo.totalQuestions }}</span>
          </div>
          <div class="interview-info__item">
            <span class="interview-info__label">Time per Question:</span>
            <span class="interview-info__value">{{ interviewInfo.duration }}</span>
          </div>
          <div class="interview-info__item">
            <span class="interview-info__label">Passing Score:</span>
            <span class="interview-info__value">{{ interviewInfo.passingScore }} / {{ interviewInfo.totalQuestions }}</span>
          </div>
        </div>

        <div class="interview-instructions">
          <h3 class="interview-instructions__title">Instructions:</h3>
          <ul class="interview-instructions__list">
            <li>Read each question carefully</li>
            <li>You have 15 seconds to answer each question</li>
            <li>Select only one option per question</li>
            <li>Click "Submit Answer" to confirm your selection</li>
            <li>You cannot change your answer once submitted</li>
            <li>The interview will auto-submit if time runs out</li>
          </ul>
        </div>
      </div>

      <div class="interview-card__footer">
        <button class="btn btn-primary btn-start" (click)="startInterview()">
          Start Interview
        </button>
      </div>
    </div>
  </div>

  <!-- Interview Questions Screen -->
  <div class="interview-questions" *ngIf="interviewStarted && !interviewCompleted">
    <div class="question-card">
      <div class="question-card__header">
        <div class="question-progress">
          <span class="question-progress__text">
            Question {{ currentQuestionIndex + 1 }} of {{ questions.length }}
          </span>
          <div class="question-progress__bar">
            <div
              class="question-progress__fill"
              [style.width.%]="((currentQuestionIndex + 1) / questions.length) * 100">
            </div>
          </div>
        </div>

        <div class="timer" [class.timer--warning]="timeRemaining <= 5">
          <span class="timer__icon">⏱</span>
          <span class="timer__value">{{ timeRemaining }}s</span>
        </div>
      </div>

      <div class="question-card__body">
        <h2 class="question-card__title">{{ currentQuestionIndex + 1 }}. {{ currentQuestion.question }}</h2>

        <div class="options-grid">
          <div
            *ngFor="let option of currentQuestion.options; let i = index"
            class="option"
            [class.option--selected]="selectedAnswer === i && !answerSubmitted"
            [class.option--correct]="isCorrectAnswer(i)"
            [class.option--wrong]="isWrongAnswer(i)"
            [class.option--disabled]="answerSubmitted"
            (click)="selectOption(i)">
            <div class="option__content">
              <div class="option__indicator">
                <span class="option__letter">{{ String.fromCharCode(65 + i) }}</span>
              </div>
              <div class="option__text">{{ option }}</div>
              <div class="option__icon" *ngIf="answerSubmitted">
                <span *ngIf="isCorrectAnswer(i)">✓</span>
                <span *ngIf="isWrongAnswer(i)">✗</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="question-card__footer">
        <button
          class="btn btn-primary btn-submit"
          [disabled]="selectedAnswer === null || answerSubmitted"
          (click)="submitAnswer()">
          Submit Answer
        </button>
      </div>
    </div>
  </div>

  <!-- Interview Results Screen -->
  <div class="interview-results" *ngIf="interviewCompleted">
    <div class="results-card">
      <div class="results-card__header">
        <div class="results-icon" [class.results-icon--pass]="hasPassed" [class.results-icon--fail]="!hasPassed">
          <span *ngIf="hasPassed">🎉</span>
          <span *ngIf="!hasPassed">📝</span>
        </div>
        <h1 class="results-card__title">
          {{ hasPassed ? 'Congratulations!' : 'Interview Completed' }}
        </h1>
      </div>

      <div class="results-card__body">
        <div class="score-display">
          <div class="score-display__value">{{ score }} / {{ questions.length }}</div>
          <div class="score-display__label">Questions Answered Correctly</div>
        </div>

        <div class="results-message" [class.results-message--pass]="hasPassed">
          <p *ngIf="hasPassed">
            Excellent work! You have successfully passed the technical interview.
            Our team will review your performance and get back to you soon.
          </p>
          <p *ngIf="!hasPassed">
            Thank you for taking the time to complete this interview.
            Unfortunately, you did not meet the passing criteria this time.
            We encourage you to review the topics and try again.
          </p>
        </div>

        <!-- <div class="results-stats">
          <div class="stat-item">
            <span class="stat-item__label">Position:</span>
            <span class="stat-item__value">{{ interviewInfo.position }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-item__label">Passing Score:</span>
            <span class="stat-item__value">{{ interviewInfo.passingScore }} / {{ interviewInfo.totalQuestions }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-item__label">Your Score:</span>
            <span class="stat-item__value">{{ score }} / {{ questions.length }}</span>
          </div>
        </div> -->
      </div>

    </div>
  </div>
</div>
